// @noflow
/* global window */
import heartbeat from 'Browser/app/Heartbeat';
import { SourceType } from 'Common/models/franchise';
import platform from 'platform';

export const playListing = async ({
  channelInformation,
  franchise,
  listing,
  navigation,
  title,
  trailer,
  slingApi,
  listingType,
  savedProgress,
  extraProps,
}) => {
  const {
    registerDynaDevice,
    setDVRStream,
    setLiveStream,
    setPlayerStream,
    togglePlayerVisibility,
    activeReceiver,
    toggleUnsupportedReceiverModal,
    playerType,
    requestReceiversStatus,
    minSupportedChromeVersion,
  } = extraProps;
  const { model, status } = activeReceiver;
  // eslint-disable-next-line camelcase
  const { name: browser, version: client_browser_version } = platform;

  if (heartbeat.shouldRefresh() && window) {
    window.location.reload(true);
  }

  const mainVersion = parseInt(client_browser_version.split('.')[0], 10);

  if (browser === 'Chrome' && mainVersion <= minSupportedChromeVersion) {
    toggleUnsupportedReceiverModal(true, 'outdatedBrowser');
    return;
  }

  if (browser !== 'Chrome' && browser !== 'Safari') {
    toggleUnsupportedReceiverModal(true, 'unsupportedBrowser');
    return;
  }

  if (!listing) {
    return;
  }

  let isSling = false;

  if (listingType === SourceType.SLING_LIVE) {
    isSling = true;

    await requestReceiversStatus();

    if (model !== 'HOPPER3' && model !== 'HPRSLNG' && model !== 'HOPPER2') {
      toggleUnsupportedReceiverModal(true, 'unsupported');
      return;
    }

    if (status && status.toLowerCase() !== 'online') {
      toggleUnsupportedReceiverModal(true, 'offline');
      return;
    }

    setLiveStream(channelInformation, true, listing);
  } else if (listing.dvr) {
    isSling = true;

    await requestReceiversStatus();

    if (model !== 'HOPPER3' && model !== 'HPRSLNG' && model !== 'HOPPER2') {
      toggleUnsupportedReceiverModal(true, 'unsupported');
      return;
    }

    if (status && status.toLowerCase() !== 'online') {
      toggleUnsupportedReceiverModal(true, 'offline');
      return;
    }

    if (
      listing.viewTimeRemaining &&
      listing.dvrDuration &&
      listing.viewTimeRemaining < listing.dvrDuration
    ) {
      // Content is in-progress, start watching from the duration - view_time_remaining
      const progress = listing.dvrDuration - listing.viewTimeRemaining;
      setDVRStream({
        dvrId: listing.programId,
        dvrListing: listing,
        dvrProgress: progress,
        contentId: listing.contentId,
      });
    } else {
      setDVRStream({ dvrId: listing.programId, dvrListing: listing, contentId: listing.contentId });
    }
  } else if (trailer) {
    isSling = false;
    if (playerType === 'sling') {
      try {
        await slingApi.stopStreaming(true);
      } catch (e) {
        console.warn('no sling api...');
      }
    }
    setPlayerStream({ stream: trailer, sourceType: SourceType.TRAILER });
  } else if (listing.playerType === 'nagra') {
    isSling = false;
    if (playerType === 'sling') {
      try {
        await slingApi.stopStreaming(true);
      } catch (e) {
        console.warn('no sling api...');
      }
    }
    console.warn('nagra streams are currently not playable');
    return;
  } else {
    isSling = false;
    if (playerType === 'sling') {
      try {
        await slingApi.stopStreaming(true);
      } catch (e) {
        console.warn('no sling api...');
      }
    }

    if (listing.modelType === 'PurchaseEventListing') {
      if (savedProgress) {
        const updatedStream = { ...listing.dynaStream, progress_seconds: savedProgress };

        setPlayerStream({
          stream: updatedStream,
          sourceType: 'est',
          contentId: listing.contentId,
        });
      } else {
        setPlayerStream({
          stream: listing.dynaStream,
          sourceType: 'est',
          contentId: listing.contentId,
        });
      }
    } else if (
      listing.modelType === 'AiringEventListing' &&
      (listing.airingType === 'linear' || listing.airingType === 'hybrid')
    ) {
      const analyticsData = {
        contentId: listing.contentIdentification.echostar_id,
        duration: listing.duration,
        genres: listing.genres,
        kind: listing.kind,
        programName: listing.name,
        originalAirDate: listing.original_air_date,
        contentUrl: listing.source.hls,
        startDateTime: listing.start_date_time,
        updatedAt: listing.updated_at,
      };
      setPlayerStream({
        stream: listing.dynaStream,
        sourceType: 'live_linear',
        contentId: listing.contentIdentification.echostar_id,
        channelInformation,
        analyticsData,
      });
    } else {
      const analyticsData = {
        contentId: listing.echostarId,
        episodeNumber: listing.episodeNumber,
        episodeName: listing.title,
        seasonNumber: listing.season,
        episodeId: listing.id,
      };
      registerDynaDevice();
      if (savedProgress) {
        const updatedStream = { ...listing.dynaStream, progress_seconds: savedProgress };
        setPlayerStream({
          stream: updatedStream,
          sourceType: 'on_demand',
          contentId: listing.contentId,
          listing,
          analyticsData,
        });
      } else {
        setPlayerStream({
          stream: listing.dynaStream,
          sourceType: 'on_demand',
          contentId: listing.contentId,
          listing,
          analyticsData,
        });
      }
    }
  }

  togglePlayerVisibility(true);

  if (!title) {
    if (franchise && franchise.franchiseName) {
      title = franchise.franchiseName;
    } else if (channelInformation && channelInformation.satellite_callsign) {
      title = channelInformation.satellite_callsign;
    } else {
      title = '';
    }
  }

  if (navigation) {
    navigation.navigate(isSling ? 'SlingPlayerPage' : 'PlayerPage', {
      channelInformation,
      franchise,
      listing,
      title,
    });
  }
};
